import React from 'react';
import { BreastClinicIntake } from './pages/BreastClinicIntake';
export function App() {
  return <BreastClinicIntake data-id="element-0" />;
}